module.exports = __webpack_public_path__ + "img/user.48cbc7a5.png";